export const config = {
    appTitle: 'SFORCE',
    apiName: 'kesz_csoport_api',
    spaClientId: 'kesz_csoport_spa',
};